<!--
  ~ Copyright (c) 2021.
  ~ 2iPartners SàRL and/or its affiliates.
  ~ All rights reserved.
  ~
  ~ 2iPartners SàRL
  ~ Route de Compois 24,
  ~ 1252 Meinier
  ~ Suisse
  ~
  ~ tel : +41 22 735 97 07
  -->

<div class="row" [formGroup]="formGroup">
  <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 mb-3">
    <div style="overflow-x: auto">
      <table aria-label="Tableau affichant les animaux de la demande d'ATM"
             class="table table-bordered table-striped table-border-purple table-head-purple">
        <thead>
        <tr>
          <th scope="col" class="text-center">#</th>
          <th scope="col" class="text-center" i18n="@@animalSpecies">Species</th>
          <th scope="col" class="text-center" i18n="@@animalCategory">Category</th>
          <th scope="col" class="text-center" i18n="@@animalGender" *ngIf="animalGenderColDisplay">Gender</th>
          <th scope="col" class="text-center" i18n="@@animalGender" *ngIf="animalTypeColDisplay">Type</th>
          <th scope="col" class="text-center" i18n="@@country" *ngIf="animalNumberColDisplay">Country</th>
          <th scope="col" class="text-center" i18n="@@animalNumber" *ngIf="animalNumberColDisplay">Number</th>
          <th scope="col" class="text-center" i18n="@@quantity">Quantity</th>
          <th scope="col" class="text-center" i18n="@@weight">Weight</th>
          <th scope="col" class="text-center" i18n="@@autopsy" *ngIf="autopsyColDisplay">Autopsy</th>
          <th scope="col" class="text-center" i18n="@@remove">Remove</th>
        </tr>
        </thead>

        <tbody>
        <tr *ngFor="let d of dataFA?.controls; let i = index">
          <th scope="row" class="text-center">{{i + 1}}</th>
          <th scope="row" class="text-center">{{d?.value?._embedded?.animalDetail?._embedded?.animalSpecies?.tag}}</th>
          <th scope="row" class="text-center">{{d?.value?._embedded?.animalDetail?._embedded?.animalCategory?.tag}}</th>
          <th scope="row" class="text-center" *ngIf="animalGenderColDisplay">
            {{d?.value?._embedded?.animalDetail?._embedded?.animalGender?.tag}}
          </th>
          <th scope="row" class="text-center" *ngIf="animalTypeColDisplay">
            {{d?.value?._embedded?.animalDetail?._embedded?.animalType?.tag}}
          </th>
          <th scope="row" class="text-center" *ngIf="animalNumberColDisplay">
            {{d?.value?._embedded?.country?.alpha2}}

          </th>
          <th scope="row" class="text-center" align="center" width="35%" *ngIf="animalNumberColDisplay">
            {{d.value.number}}
            <!-- <app-input-animal-number *ngIf="showNumberInput(d)" controlName="number" [formControl]="d.value" [index]="i" [formGroup]="formGroup"
                                      [animalDetail]="d?.value?._embedded?.animalDetail" [disableEnterKeyPress]="true"
                                      [showLabel]="false">
             </app-input-animal-number> -->

          </th>
          <th scope="row" class="text-center">{{d?.value?.quantity}}</th>
          <th scope="row" class="text-center">{{d?.value?.weightE}}</th>
          <th scope="row" class="text-center" *ngIf="autopsyColDisplay">{{d?.value?._embedded?.autopsy?.tag}}</th>
          <td scope="row" class="text-center" align="center">
            <button class="btn btn-outline-danger btn-icon-only btn-circle btn-thick btn-sm" (click)="removeAnimal(i)">
              <i class="fa fa-times fa-lg"></i>
            </button>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>

  <div *ngIf="control?.invalid" class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 invalid-feedback d-block">
    <div *ngIf="control?.hasError('required')" i18n="@@oneAnimalRequired">At least one animal is required</div>
  </div>
</div>
